import React, { useState, useEffect } from "react";

const IdleTimer = ({ onIdle }) => {
  const [idleTimer, setIdleTimer] = useState(null);

  // Set up the idle timer when the component mounts
  useEffect(() => {
    const resetIdleTimer = () => {
      clearTimeout(idleTimer);

      const newIdleTimer = setTimeout(() => {
        onIdle();
      }, 5 * 60 * 1000); // 5 minutes (5 * 60 seconds * 1000 milliseconds)

      setIdleTimer(newIdleTimer);
    };

    const handleUserActivity = () => {
      resetIdleTimer();
    };

    // Add event listeners for user activity
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);
    document.addEventListener("mousedown", handleUserActivity);
    document.addEventListener("touchstart", handleUserActivity);

    // Clean up event listeners on component unmount
    return () => {
      clearTimeout(idleTimer);
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
      document.removeEventListener("mousedown", handleUserActivity);
      document.removeEventListener("touchstart", handleUserActivity);
    };
  }, [idleTimer, onIdle]);

  return <></>; // Empty component, no UI elements to render
};

export default IdleTimer;
